import axios from "axios";
import localforage from "localforage";

const b64toBlob = async (b64Data) => {
  const base64Response = await fetch(b64Data);
  return await base64Response.blob();
};

export function getFileURI(message) {
  return new Promise(async (resolve, reject) => {
    try {
      const base64Cached = await localforage.getItem(message.id); // recovery data cached

      if (base64Cached) {
        const blob = await b64toBlob(base64Cached);
        const url = URL.createObjectURL(blob);

        resolve(url);
      } else {
        const response = await axios.get(message.attachment_url, {
          responseType: "blob",
        });

        const reader = new FileReader();

        reader.readAsDataURL(response.data);
        reader.onloadend = async () => {
          const base64Data = reader.result;

          localforage.setItem(message.id, base64Data).then(async () => {
            const blob = await b64toBlob(base64Data);
            const url = URL.createObjectURL(blob);

            resolve(url);
          });
        };
      }
    } catch (error) {
      reject();
    }
  });
}

export function getBase64(file) {
  return new Promise((resolve, reject) => {
    var reader = new FileReader();

    reader.readAsDataURL(file);

    reader.onloadend = function () {
      resolve(reader.result);
    };

    reader.onerror = function (error) {
      reject(error);
    };
  });
}
